import { t } from '@lingui/core/macro';
import { HttpError, NetworkError } from '@luminovo/api-contracts';
import { transEnum } from '@luminovo/frontend-utils';

import { errorCodeTranslations } from './errorCodeTranslations';

export function formatError(err: Error): string {
    if (err instanceof NetworkError) {
        return t`Network error: please check your internet connection and try again.`;
    }
    if (err instanceof HttpError) {
        return transEnum(err.code, errorCodeTranslations);
    }
    return t`An unexpected error occurred.`;
}
